import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../components/common";
import { pathConstants } from "../../../routes/pathContants";
import AllSections from "../../appPages/AllSections";

export const SMSectionOrders = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Section Orders"
      headerDescription="Choose your section to manage order"
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <AllSections isViaSellMode={true} />
    </RoutedModal>
  );
};
